var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutoLoanIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_22447)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_22447)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.4234 15.0077L20.9181 14.334L20.498 11.8111C20.4138 11.305 20.1527 10.8451 19.7612 10.5135C19.3697 10.1818 18.8732 9.99984 18.3601 10H12.6408C12.1278 10.0001 11.6316 10.1821 11.2403 10.5138C10.849 10.8454 10.588 11.3051 10.5039 11.8111L10.0837 14.334L9.57842 15.0077C9.20328 15.5078 9.00033 16.1159 9 16.7411V20.8344C9.00024 21.0258 9.07638 21.2093 9.2117 21.3446C9.34702 21.4799 9.53049 21.556 9.72186 21.5563H21.2791C21.4704 21.556 21.6539 21.4799 21.7892 21.3446C21.9245 21.2093 22.0007 21.0258 22.0009 20.8344V16.7411C22.0008 16.1161 21.7982 15.5079 21.4234 15.0077Z",
    fill: "#E2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1801 18.3292C19.6912 18.3292 20.1056 17.9149 20.1056 17.4037C20.1056 16.8926 19.6912 16.4783 19.1801 16.4783C18.669 16.4783 18.2546 16.8926 18.2546 17.4037C18.2546 17.9149 18.669 18.3292 19.1801 18.3292Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7764 18.3292C12.2875 18.3292 12.7019 17.9149 12.7019 17.4037C12.7019 16.8926 12.2875 16.4783 11.7764 16.4783C11.2653 16.4783 10.851 16.8926 10.851 17.4037C10.851 17.9149 11.2653 18.3292 11.7764 18.3292Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2791 21.5563H19.8344V22.2782C19.8347 22.4696 19.9108 22.653 20.0461 22.7884C20.1814 22.9237 20.3649 22.9998 20.5563 23.0001H21.2781C21.4695 22.9998 21.653 22.9237 21.7883 22.7884C21.9236 22.653 21.9998 22.4696 22 22.2782V20.8345C21.9998 21.0257 21.9237 21.209 21.7886 21.3443C21.6535 21.4796 21.4703 21.5558 21.2791 21.5563Z",
    fill: "#B6C1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72186 21.5563H11.1665V22.2782C11.1663 22.4696 11.0901 22.653 10.9548 22.7884C10.8195 22.9237 10.636 22.9998 10.4447 23.0001H9.72186C9.53049 22.9998 9.34702 22.9237 9.2117 22.7884C9.07638 22.653 9.00024 22.4696 9 22.2782V20.8345C9.00024 21.0258 9.07638 21.2093 9.2117 21.3446C9.34702 21.48 9.53049 21.5561 9.72186 21.5563Z",
    fill: "#B6C1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2357 18.6678H14.3483C14.1569 18.6681 13.9734 18.7442 13.8381 18.8795C13.7028 19.0149 13.6266 19.1983 13.6264 19.3897C13.6266 19.5811 13.7028 19.7646 13.8381 19.8999C13.9734 20.0352 14.1569 20.1113 14.3483 20.1116H17.2357C17.4271 20.1113 17.6106 20.0352 17.7459 19.8999C17.8812 19.7646 17.9573 19.5811 17.9576 19.3897C17.9573 19.1983 17.8812 19.0149 17.7459 18.8795C17.6106 18.7442 17.4271 18.6681 17.2357 18.6678Z",
    fill: "#6C7DE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_22447",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_22447"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_22447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoLoanIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auto_loan_icon.2d2f909d4bcb723547f3c4b644bf3605.svg";